var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdminIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.68448 0.0508282L14.6151 3.315C14.8004 3.40287 14.919 3.58922 14.919 3.79461V9.43357C14.919 14.0233 10.9423 16.181 8.04022 17.7575L7.71306 17.9354C7.63366 17.9778 7.54685 18 7.45897 18C7.37214 18 7.28533 17.9778 7.20593 17.9354L6.87876 17.7575C3.97565 16.181 0 14.0233 0 9.43356V3.79459C0 3.5892 0.118587 3.40286 0.303863 3.31498L7.23451 0.0508188C7.37638 -0.0169396 7.54261 -0.0169302 7.68448 0.0508282ZM5.55987 3.59344C3.90926 3.59344 2.56675 4.93701 2.56675 6.58761C2.56675 8.23822 3.90926 9.58073 5.55987 9.58073C5.57787 9.58073 5.59587 9.58073 5.61386 9.57967L6.16231 10.1281H6.94684V11.2229H8.0416V12.0085L8.90025 12.8661H11.8383V9.92801L8.55192 6.64056C8.55299 6.62362 8.55299 6.60562 8.55299 6.58762C8.55299 4.93702 7.21047 3.59345 5.55987 3.59345V3.59344ZM5.55987 4.65221C6.62604 4.65221 7.49423 5.52144 7.48469 6.6829L7.44764 7.03229L10.7796 10.3663V11.8073H9.33858L9.10036 11.5701V10.1641H8.00561V9.06936H6.60062L6.00242 8.47221L5.55986 8.52197C4.49368 8.52197 3.6255 7.65484 3.6255 6.58761C3.6255 5.52144 4.49368 4.65221 5.55986 4.65221H5.55987ZM5.60655 5.82382C5.16823 5.82382 4.81249 6.17956 4.81249 6.61789C4.81249 7.05622 5.16823 7.41197 5.60656 7.41197C6.04488 7.41197 6.40063 7.05622 6.40063 6.61789C6.40063 6.17956 6.04487 5.82382 5.60655 5.82382Z",
    fill: "#38C669"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminIcon);
export default __webpack_public_path__ + "static/media/admin-icon.171e679b4dd7693cf4edb4a8b75d6119.svg";
export { ForwardRef as ReactComponent };